import { ApplicationType, ComponentType, PBXSettingsType } from './../constants/constants';

export interface PBXSettingsRequirement {
  applicationType: ApplicationType;
  requiredComponentTypes: ComponentType[];
  pbxType: PBXSettingsType;
}

export const PBXSettingsRequirements: PBXSettingsRequirement[] = [
  {
    applicationType: ApplicationType.MIVOICE_5000,
    requiredComponentTypes: [ComponentType.MIVOICE_5000],
    pbxType: PBXSettingsType.MIVOICE_5000
  },
  {
    applicationType: ApplicationType.OPEN_SCAPE_VOICE,
    requiredComponentTypes: [ComponentType.OPEN_SCAPE_VOICE],
    pbxType: PBXSettingsType.OPEN_SCAPE_VOICE
  },
  {
    applicationType: ApplicationType.OPEN_SCAPE_4K,
    requiredComponentTypes: [ComponentType.OPEN_SCAPE_4K_RMX, ComponentType.OPEN_SCAPE_4K_CSTA],
    pbxType: PBXSettingsType.OPEN_SCAPE_4K
  },
  {
    applicationType: ApplicationType.MIVOICE_BUSINESS,
    requiredComponentTypes: [ComponentType.MIVOICE_BUSINESS],
    pbxType: PBXSettingsType.MIVOICE_BUSINESS
  },
];